<app-header></app-header>

<section class="section bg-light d-table w-100" style="background: url('../../assets/images/background/build.png') bottom no-repeat;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-4 mb-3">
        <h4>Add Your Products</h4>
        <p>Add Your Products & share payment links with your customers.</p>
      </div>
      <div class="col-md-4 mb-3">
        <h4>Add Your Products</h4>
        <p>Add Your Products & share payment links with your customers.</p>
      </div>
      <div class="col-md-4 mb-3">
        <h4>Add Your Products</h4>
        <p>Add Your Products & share payment links with your customers.</p>
      </div>
      <div class="card shadow rounded border-0 ms-lg-4">
        <div class="card-body">
          <h5 class="card-title text-center">Team Member Sign Up</h5>
          <form class="login-form mt-4" [formGroup]="signupForm" (submit)="onSignup()" novalidate>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">First Name <span class="text-danger">*</span></label>
                  <div class="form-icon position-relative">
                    <i data-feather="user" class="fea icon-sm icons"></i>
                    <input type="text" class="form-control px-2" placeholder="First Name" formControlName="firstName"
                           [ngClass]="formValidator.formErrors.firstName ? 'border-danger':''" autocomplete="off"
                           [readonly]="true">
                    <div class="text-danger fs-7" *ngIf="formValidator.formErrors.firstName">
                      {{ formValidator.formErrors.firstName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">Last Name <span class="text-danger">*</span></label>
                  <div class="form-icon position-relative">
                    <i data-feather="user" class="fea icon-sm icons"></i>
                    <input type="text" class="form-control px-2" placeholder="Last Name" formControlName="lastName"
                           [ngClass]="formValidator.formErrors.lastName ? 'border-danger':''" autocomplete="off"
                           [readonly]="true">
                    <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.lastName">
                      {{ formValidator.formErrors.lastName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">Role <span class="text-danger">*</span></label>
                  <select class="form-control form-select" [attr.disabled]="true" placeholder="roles" formControlName="roleId">
                    <option *ngFor="let role of roles" [value]="role.id">
                      {{ role.name }}
                    </option>
                  </select>
                  <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.roleId">
                    {{ formValidator.formErrors.roleId }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">{{ 'Signup.Email' | translate }} <span class="text-danger">*</span></label>
                  <div class="form-icon position-relative">
                    <i data-feather="mail" class="fea icon-sm icons"></i>
                    <input type="email" class="form-control px-2" placeholder="{{ 'Signup.Email' | translate }}"
                           formControlName="email" autocomplete="off" [readonly]="true"
                           [ngClass]="formValidator.formErrors.email ? 'border-danger':''">
                    <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.email">
                      {{ formValidator.formErrors.email }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">Phone Number <span class="text-danger">*</span></label>
                  <div class="form-icon position-relative">
                    <i data-feather="phone" class="fea icon-sm icons"></i>
                    <input type="text" class="form-control px-2" placeholder="Phone Number"
                           formControlName="mobile" [ngClass]="formValidator.formErrors.mobile ? 'border-danger':''">
                    <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.mobile">
                      {{ formValidator.formErrors.mobile }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label mb-0">{{ 'Signup.Password' | translate }} <span class="text-danger">*</span></label>
                  <div class="form-icon position-relative">
                    <i data-feather="key" class="fea icon-sm icons"></i>
                    <input type="password" class="form-control px-2" placeholder="{{ 'Signup.Password' | translate }}" formControlName="password"
                           [ngClass]="formValidator.formErrors.password ? 'border-danger':''">
                    <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.password">
                      {{ formValidator.formErrors.password }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-grid">
                  <button class="btn btn-primary" type="submit" [disabled]="signupForm.invalid">
                    Join Team
                  </button>
                  <p class="lets">
                    Let's set up your account. Already have one?
                    <a class="text-primary" routerLink="/signup">Sign in here.</a>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<recaptcha
  [size]="'invisible'"
  [hide]="false"
>
</recaptcha>

<app-footer></app-footer>
